<template>
    <div class="">
        <div class="actions__container">
            <div class="flex items-center gap-2">
                <router-link
                    class="btn btn-primary w-40 inline-block mr-1 mb-2"
                    :to="{ name: 'popular-direction-create', query: $route.query }"
                >
                    Создать
                </router-link>

                <CruiseTypeChoose
                    :types="getCruiseTypes"
                    :is-loading="isCruiseTypesLoading"
                    @on-type-click="handleTypeClick"
                />
            </div>
        </div>

        <ContentSearch />

        <ContentTable
            :table-actions="tableActions"
            :headers="tableHeaders"
            :table-rows="tableData"
            :meta="pagination"
            :loading="loading"
            @edit="editAction"
            @delete="deleteAction"
        />

        <PopupDeleteModal
            :is-open="modalDeleteOpen"
            :entity-name="modalDeleteCaption"
            :modal-data="modalDeleteRow"
            @update:isOpen="modalDeleteOpen = $event"
            @deleteModalAccepted="onDeleteModalAccepted"
        />
    </div>
</template>

<script>
import ContentTable from '@/components/tables/ContentTable';
import PopupDeleteModal from '@/components/modals/PopupDeleteModal';
import ContentSearch from '@/components/base/ContentSearch';
import CruiseTypeChoose from '@/components/CruiseTypes/CruiseTypeChoose.vue';
import { pageMixin } from '@/mixins/pageMixin';
import { cruiseTypesOptionsMixin } from '@/mixins/form/cruise-types-options.mixin';

export default {
    name: 'Main',
    components: { ContentSearch, PopupDeleteModal, ContentTable, CruiseTypeChoose },
    mixins: [pageMixin, cruiseTypesOptionsMixin],
    async beforeRouteUpdate(to, from, next) {
        await this.fetchData({ type: this.getCruiseTypes[0].id, ...to.query });
        next();
    },
    data() {
        return {
            tableActions: [
                { name: 'edit', title: 'редактировать', icon: 'Edit2Icon', cbName: 'edit' },
                { name: 'delete', title: 'удалить', class: 'bg-red-400', icon: 'Trash2Icon', cbName: 'delete' },
            ],
            addButtonDelete: false,
            tableHeaders: [
                { field: 'id', label: '#' },
                { field: 'preview_title', label: 'Превью' },
                { field: 'title', label: 'Название' },
                { field: 'slug', label: 'Ссылка' },
                { field: 'parent_name', label: 'Родитель' },
            ],
            loading: false,
            isCruiseTypesLoading: false,
            tableData: [],
            pagination: null,
            modalDeleteOpen: false,
            modalDeleteCaption: null,
            modalDeleteRow: null,
        };
    },
    async mounted() {
        this.$store.commit('main/setPageHeader', 'Популярные направления');

        if (!this.getCruiseTypes.length) await this.fetchCruiseTypes();
        if (this.$route.query.type === undefined) {
            await this.$router.push({ query: { type: this.getCruiseTypes[0].id, ...this.$route.query } });
        } else {
            await this.fetchData({ type: this.getCruiseTypes ? this.getCruiseTypes[0]?.id : 0, ...this.$route.query });
        }
    },
    methods: {
        async fetchData(params) {
            try {
                this.loading = true;
                const { data } = await this.axios.get('/popular-directions', { params });
                this.tableData = data.data;
                this.pagination = data.meta;

                this.loading = false;
            } catch (ex) {
                this.loading = false;
                console.log('cant fetch data: ' + ex);
            }
        },

        editAction(row) {
            // this.$router.push({ name: 'popular-direction-edit', params: { id: row.id } });
            this._pMTransitionToEditPageWithQuery('popular-direction-edit', { id: row.id });
        },
        deleteAction(row) {
            this.modalDeleteOpen = true;
            this.modalDeleteCaption = 'направление';
            this.modalDeleteRow = row;
        },
        onDeleteModalAccepted(data) {
            this.axios
                .delete('/popular-directions/' + data.id)
                .then(() => {
                    this.fetchData(this.$route.query);
                    this.modalDeleteOpen = false;
                })
                .catch((ex) => {
                    this.$notify({
                        title: 'Ошибка',
                        text: ex.response.data.message,
                        type: 'error',
                    });
                });
        },
        async handleTypeClick() {
            await this.fetchData(this.$route.query);
        },
    },
};
</script>

<style scoped></style>
